import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import { priceFormat } from "utils/format";
import classNames from "classnames";
import { Trash, Trash2 } from "react-feather";
import { Button, Card, CardBody } from "reactstrap";

import { TableButton } from "components/TableButton";
import { Cut } from "components/Cut";

import "./ordersToProviderProductTableNew.scss";
import { SkladPopup } from "features/Orders/SkladPopup";
import { BarChart } from "components/BarChart";
import { CutLink } from "components/CutLink";
import { useNomenclatureModal } from "contexts/NomenclatureModalContext";

export const OrdersToProviderProductTableNew = ({ products, setProducts, setSelected, selected, setPrice }) => {
  const { openNomenclatureModal } = useNomenclatureModal();
  const removeProductsHandler = (id = null) => {
    if (id) {
      setProducts((prev) => prev.filter(v => v.id !== id));
      return;
    }
    setProducts((prev) => prev.filter(v => !selected.includes(v.id)));
    setSelected([]);
  };

  const productHandler = (oldData, newData, row) => {
    setProducts((prev) => {
      const index = prev.findIndex((val) => val.index === row.index);
      prev[index].summ = row.count * row.price;
      return [...prev];
    });
  };

  const selectRow = {
    mode: "checkbox",
    bgColor: "#bfbfbf",
    onSelect: (row, isSelect, rowIndex, e) => {
      setSelected((prev) => {
        if (!isSelect) {
          prev.splice(
            prev.findIndex((val) => val === row.id),
            1
          );
          return [...prev];
        }
        return [...prev, row.id];
      });
    },
    onSelectAll: (isSelect, rows, e) => {
      if (!isSelect) {
        setSelected([]);
      } else {
        setSelected(products.map((val) => val.id));
      }
    },
  };

  const tableProductsColumns = [
    {
      dataField: "index",
      text: "№",
      headerStyle: (colum, colIndex) => {
        return { width: "2%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "brand",
      text: "Бренд",
      formatter: (cell, row) => <CutLink
        onClick={() => openNomenclatureModal(row.nomenclature?.id)}
        nomenclature={row.nomenclature}
      >
        {row.nomenclature?.brand}
      </CutLink>,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "article",
      text: "Артикул",
      formatter: (cell, row) => <CutLink
        onClick={() => openNomenclatureModal(row.nomenclature?.id)}
        nomenclature={row.nomenclature}
      >
        {row.nomenclature?.article}
      </CutLink>,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      editable: false,
      footer: () => null,
      clickToSelect: false,
    },
    {
      dataField: "name",
      text: "Наименование",
      formatter: (cell, row) => <CutLink
        onClick={() => openNomenclatureModal(row.nomenclature?.id)}
        nomenclature={row.nomenclature}
      >
        {row.nomenclature?.name}
      </CutLink>,
      headerStyle: (colum, colIndex) => {
        return { width: "21%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "price",
      text: "Цена",
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      formatter: (cell) => priceFormat(cell),
      headerClasses: () => "right",
      classes: () => classNames("right bold"),
      footer: () => null,
    },
    {
      dataField: "count",
      text: "Кол-во",
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
      headerClasses: () => "right",
      footerClasses: () => "right",
      classes: () => "right",
      footer: (columnData) => {
        const total = columnData.reduce((acc, item) => acc + parseInt(item), 0);
        return total;
      },
    },
    {
      dataField: "summ",
      text: "Сумма",
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
      formatter: (cell, row) => priceFormat(cell),
      headerClasses: () => "right",
      footerClasses: () => "right bold",
      classes: () => "right bold",
      editable: false,
      footer: (columnData) => {
        const total = columnData.reduce(
          (acc, item) => acc + parseFloat(item),
          0
        );
        return total && priceFormat(total);
      },
    },
    {
      dataField: "priceDifference",
      text: "Разница с тек.себ.",
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
      formatter: (cell, row) => <>{cell} {cell ? '%' : ''}</>,
      headerClasses: () => "right",
      classes: () => "right",
      editable: false
    },
    {
      dataField: "providerName",
      text: "Поставщик",
      formatter: (cell, row) => <span><Cut>{cell}</Cut>
        {row.offer?.length > 0 &&
          <div className="offersProvider">
            {row.offer.slice(0, 5).map(offer => <div key={offer.id} onClick={() => setPrice(row, offer)}>
              {offer.providerName} - {priceFormat(offer.cost)} - {offer.deliveryTimeText}
            </div>)}
          </div>
        }
      </span>,
      classes: () => "offersPopup",
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      footer: () => null,
      editable: false,
    },
    {
      dataField: "abc",
      text: "ABC",
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
      footer: () => null,
      editable: false,
    },
    {
      dataField: "status",
      text: "Статус",
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
      footer: () => null,
      editable: false,
    },
    {
      dataField: "minStock",
      text: "Мин.Ост",
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
      footer: () => null,
      editable: false,
    },
    {
      dataField: "marketplacePrice",
      text: "Площадки",
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell, row) => priceFormat(row.nomenclature?.marketplacePrice),
      headerClasses: () => "right",
      footerClasses: () => "right",
      classes: () => "right",
      editable: false,
    },
    {
      dataField: "sold",
      text: "Продано",
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      headerClasses: () => "right",
      footerClasses: () => "right",
      classes: () => "right",
      editable: false,
    },
    {
      dataField: "inStockAll",
      text: "Ост.",
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
      formatter: (cell, row) => (
        <div className="warehouse-container">
          {(cell || row.inStockAll) && (
            <SkladPopup row={row}>
              <BarChart
                color={cell > 0 ? "green" : "red"}
                count={row.inStockAll}
              />
            </SkladPopup>
          )}
        </div>
      ),
      headerClasses: () => "right",
      classes: (cell) => "right",
      footer: () => null,
      editable: false,
    },
    {
      dataField: "ordered",
      text: "Заказано всего",
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
      headerClasses: () => "right",
      classes: (cell) => "right",
      footer: () => null,
      editable: false,
    },
    {
      dataField: "",
      text: "",
      formatter: (cell, row) => (
        <TableButton
          Icon={Trash2}
          onClick={() => removeProductsHandler(row.id)}
        />
      ),
      headerStyle: (colum, colIndex) => {
        return { width: "3%" };
      },
      footer: () => null,
      editable: false,
    },
  ];

  return (
    <>

      {selected.length > 0 &&
        <Card >
          <CardBody className="pt-0 pb-0">
            <Button onClick={() => removeProductsHandler()} color="danger">
              <Trash size="15" /> Удалить
            </Button>
          </CardBody>
        </Card>
      }
      <BootstrapTable
        wrapperClasses="orders-to-provider-product"
        keyField="id"
        data={products}
        hover={true}
        columns={tableProductsColumns}
        bootstrap4
        bordered={false}
        cellEdit={cellEditFactory({
          mode: "click",
          blurToSave: true,
          afterSaveCell: (oldData, newData, row) =>
            productHandler(oldData, newData, row),
        })}
        selectRow={selectRow}
      />
    </>
  );
};
